import React from "react";
import { AlertTriangle } from "lucide-react";
import Button from "../../../components/Buttons/Button/Button";
import ButtonDelete from "../../../components/Buttons/ButtonDelete/ButtonDelete";
import ButtonClose from "../../../components/Buttons/ButtonClose/ButtonClose";
import "./CancelSubscriptionModal.css";

function CancelSubscriptionModal({
  open,
  t,
  loading,
  disabled,
  onClose,
  onConfirm,
}) {
  if (!open) return null;

  return (
    <div className="suscriptions-modal-overlay" role="dialog" aria-modal="true">
      <div className="suscriptions-modal-dialog">
        <div className="suscriptions-modal-header">
          <div className="suscriptions-modal-title-section">
            <AlertTriangle size={20} aria-hidden="true" stroke="var(--primary)" />
            <h3 className="suscriptions-modal-title">
              {t("page.cancelConfirm.title")}
            </h3>
          </div>
          <ButtonClose
            onClick={onClose}
            ariaLabel={t("page.cancelConfirm.keep")}
            disabled={loading || disabled}
          />
        </div>
        <p className="suscriptions-modal-message">
          {t("page.cancelConfirm.message")}
        </p>
        <div className="suscriptions-modal-actions">
          <Button
            type="button"
            variant="secondary"
            size="sm"
            disabled={loading}
            onClick={onClose}
          >
            {t("page.cancelConfirm.keep")}
          </Button>
          <ButtonDelete
            type="button"
            variant="delete"
            size="sm"
            disabled={loading || disabled}
            onClick={onConfirm}
          >
            {t("page.cancelConfirm.confirm")}
          </ButtonDelete>
        </div>
      </div>
    </div>
  );
}

export default CancelSubscriptionModal;
